$(document).on("click",".tab-headings",function() {
  $(".tab-headings").removeClass("active-tab");
  $(this).addClass("active-tab");

  var $target = $(this).data('tab');
  $(".tab-content-wrapper").removeClass("active-content");
  $(`.tab-content-wrapper.${$target}`).addClass("active-content");
});

$(document).on("click",".mobile-tab-headings",function() {
  $(this).toggleClass("active-content");
});

$(document).on("click",".faqs-accordion-content .tab_name",function() {
 $(this).toggleClass('active-tab').next().slideToggle();
});

$(document).on("click",".product-information-wrapper .tab-content-wrapper dt",function() {
 $(this).toggleClass('active-tab').next().slideToggle();
});

$(document).on("click",".part-payment span",function() {
  $(".buy-now-pay-later").show();
});

$(document).on("click",".x-mas-message-arrow",function() {
 $(this).toggleClass('active').next().slideToggle();
});

$(document).on("click",".buy-now-pay-later .icon-close",function() {
  $(".buy-now-pay-later").hide();
});

$(document).on("change",".price-per-item__container .quantity__input",function() {
    if($(this).val() > 2){
      $('.qty-discount-text').html("Buy 3+, Get 10% off");
    }else if($(this).val() > 1){
      $('.qty-discount-text').html("Buy 3, Get 10% off");
    }else{
      $('.qty-discount-text').html("Buy 2, Get 5% off");
    }
  var $form = $(this).attr('form');
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".price-per-item__container")) {
    setTimeout(() => {
      const price = parseFloat(document.querySelector(".price-per-item__container").getAttribute("data-price"));
      const total_price = price * 2;
      const discount = 0.05;
      const total = (total_price * discount).toFixed(2) / 100;
      $('.calculate-price').html(`Buy 2, Get $${total} off`);
    }, 1000);
  }
});

// $(document).on("change", ".price-per-item__container .quantity__input", function () {
//   const price = parseFloat(document.querySelector(".price-per-item__container").getAttribute("data-price"));
//   const quantity = parseInt($(this).val());
//   let total_price;
//   let discount;

//   if (quantity > 2) {
//     total_price = price * (quantity + 1);
//     discount = 0.10;
//     $('.calculate-price').html(`Buy ${parseInt(quantity) + 1}, Get $${(total_price * discount / 100).toFixed(2)} off`);
//   } else if (quantity > 1) {
//     total_price = price * 3;
//     discount = 0.10;
//     $('.calculate-price').html(`Buy 3, Get $${(total_price * discount / 100).toFixed(2)} off`);
//   } else {
//     total_price = price * quantity;
//     discount = 0.05;
//     $('.calculate-price').html(`Buy ${parseInt(quantity) + 1}, Get $${((total_price * 2) * discount / 100).toFixed(2)} off`);
//   }

// });

$(document).on("click", ".product__title .stamped-badge", function () {
  $('html, body').animate({
    scrollTop: $("#stamped-main-widget").offset().top
  }, 1000);
});

$(document).on("click",".footer-block.link_list h2",function() {
  if(window.innerWidth < 750){
    $(this).toggleClass('active');
    $(this).next().toggle();
  }
});

$(document).on("click",".faq-que",function() {
 $(this).toggleClass('active').next().slideToggle();
});

$('.category-option').click(function(){
  var cat = $(this).data('category');
  $('.category-option').removeClass('active');
  $(this).addClass('active');
  if(cat == 'show-all'){
    $('.sub-faq').show();
  }else{
    $('.sub-faq').hide();
    $('.sub-faq[data-type='+cat+']').show();
  }
});

$('#faq-search').keyup(function(){
  var $q = $(this).val().toLowerCase();
    //   $category = $('.category-option.active').data('category');
    //   if($category == 'show-all'){
    //     var $targets = $('.faq-wrapper');
    //   }else{
    //     var $targets = $('.faq-wrapper[data-type='+$category+']');
    //   }
    // console.log($q)
    // console.log($category)
    var $targets = $('.faq-wrapper');
    $targets.each(function(){
      var $thiscontent = $(this).text().toLowerCase();
      if ($thiscontent.indexOf($q) > -1) {
        $(this).show();
      }else{
        $(this).hide();
      }
    });
});

function searchFunction() {
  var input, filter, ul, li, s, p, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    p = li[i].getElementsByTagName("p")[0];
    s = li[i].getElementsByTagName("span")[0];
    txtValue = (s.textContent || s.innerText) + " " + (p.textContent || p.innerText) ;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

$(document).on("click",".checkout-btn, #CartDrawer-Checkout-btn",function() {
  $('.cart-upsell-overlay').addClass("overlay-show");
  $('.cart-upsell-drawer').addClass("open-drawer");
  $('#CartDrawer-Checkout').prop('disabled', false);
  resizecart();
});


$(document).on("click",".cart-upsell-overlay, .cart-upsell-header .icon-close, .cart-upsell-footer .go-back-button",function() {
  $('.cart-upsell-overlay').removeClass("overlay-show");
  $('.cart-upsell-drawer').removeClass("open-drawer");
});

function resizecart(){
 var headerheight = $(".cart-upsell-header").height();
 var footerheight = $(".cart-upsell-footer").height();
$('.cart-upsell-products').css('height', $(window).height() - headerheight - footerheight - 60 );
$('.cart-whey-products').css('height', $(window).height() - $(".whey-freebie-header").height());
$('.cart-bogo-products').css('height', $(window).height() - $(".bogo-freebie-header").height());
  // Collection grid banner
 $('.collection-grid-image img').css("max-height",$('.UNX-product-col.UNX-grid-card.product-item').height());
}
resizecart();
$(window).resize(function(){
 resizecart();
});

$(document).on("change",".upsell-variant",function() {
 var regularPrice = $('option:selected',this).attr('the_regular_price');
 var discountedPrice = $('option:selected',this).attr('the_discounted_price');
 var the_discounted_percentage = $('option:selected',this).attr('the_discounted_percentage');
 var the_save_price = $('option:selected',this).attr('the_save_price');
 var $item = $(this).parents('.upsell-item')
 $item.find('.sale_was__price').html(regularPrice);
 $item.find('.sale-new-price').html(discountedPrice);
 $item.find('.discount').html( the_discounted_percentage);
 $item.find('.save-price').html(the_save_price);
 if($('option:selected',this).data('image')){
   $item.find('img').removeAttr('srcset').attr('src',$('option:selected',this).data('image'));
 }
});

$('.tab-content-wrapper img[data-src]').each(function(){
  $(this).attr("src",$(this).data('src'));
});

function UpdateTop(){
  var Aheight = $('.utility-bar').height();
  var Acss = '<style id="ancss">.shopify-section-header-sticky{ top: '+Aheight+'px; }</style>';
  $('#ancss').remove();
  $('body').append(Acss);
}

UpdateTop();

$(window).resize(function(){
  UpdateTop();
});

$('.copy-icon-wrapper svg').click(function(){
  var temp = $("<input>");
  var $parents = $(this).parents('.right-content-wrapper');
  $("body").append(temp);
  temp.val($parents.find('strong').text()).select();
  document.execCommand("copy");
  temp.remove();
  $parents.find('.tooltip').fadeIn(500);
  setTimeout(function(){
    $parents.find('.tooltip').fadeOut(500);
  },2000);
});

var eventsTriggered = {
  click: false,
  mousemove: false,
  scroll: false
};

function handleEvents(event) {
  var eventType = event.type;
  if (!eventsTriggered[eventType]) {
      if(window.urls){
        eventsTriggered[eventType] = true;
        for (var i = 0; i < window.urls.length; i++) {
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = window.urls[i];
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        }
      }
  }

  if (eventsTriggered.click || eventsTriggered.mousemove || eventsTriggered.scroll) {
    $(document).off('click mousemove scroll', handleEvents);
  }
}

window.External_Urls = [] || window.External_Urls;

var KlaviyoPriorLoad = false;
var $url = new URL(window.location.href);

// if(window.location.pathname == '/pages/get-20-off-at-elite-supplements-the-glen' || window.location.pathname == '/pages/win-10k-worth-of-supps' || window.location.pathname == '/pages/get-15-off-at-elite-supps-penrith' || window.location.pathname == '/pages/perth-warehouse-sale'){
//   KlaviyoPriorLoad = true;
// }
// if($url.searchParams.get("utm_source") == 'google' && $url.searchParams.get("utm_medium") == 'cpc'){
//   KlaviyoPriorLoad = true;
// }

// if(KlaviyoPriorLoad == true){
//     var s = document.createElement('script');
//             s.type = 'text/javascript';
//             s.async = true;
//             s.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Qh5vLD";
//             var x = document.getElementsByTagName('script')[0];
//             x.parentNode.insertBefore(s, x);
//    // KLAVIYO APP BLOCK
//    // !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
// }else{
//   window.External_Urls.push("https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Qh5vLD");
// }

function handleEventsForExternal(event) {
    // GTM
    // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://metrics.elitesupps.com.au/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MRV3S86');
      
    for (var i = 0; i < window.External_Urls.length; i++) {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = window.External_Urls[i];
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    } 
  $(document).off('click mousemove scroll', handleEventsForExternal);
}

$(document).on('click mousemove scroll', handleEvents);
setTimeout(function(){
  $(document).on('click mousemove scroll', handleEventsForExternal);
},3000);

// function executeLogic() {
//   const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
//   reviewWidgets.forEach(widget => {
//     const ariaLabel = widget.getAttribute('aria-label');
//     const starRatingMatch = ariaLabel.match(/(\d+(\.\d+)?) stars/);
//     const reviewCountMatch = ariaLabel.match(/(\d+) ratings/);
//     let starRating = starRatingMatch ? parseFloat(starRatingMatch[1]).toFixed(1) : null;
//     const reviewCount = reviewCountMatch ? reviewCountMatch[1] : null;
//     if (starRating && (parseFloat(starRating) % 1 === 0)) {
//       starRating = parseInt(starRating);
//     }
//     if (starRating && reviewCount > 0) {
//       if (!widget.nextSibling || !widget.nextSibling.classList || !widget.nextSibling.classList.contains('reviews__details')) {
//         const reviewContainer = document.createElement('div');
//         reviewContainer.classList.add('reviews__details');
//         reviewContainer.innerHTML = `<div class="reviews__averange">${starRating}</div><div class="reviews__reviews">(${reviewCount})</div>`;
//         widget.parentNode.insertBefore(reviewContainer, widget.nextSibling);
//       }
//     } else if (reviewCount <= 0 || reviewCount === null){
//     }
//   });
// }

// var observer = new MutationObserver(mutationsList => {
//     for (let mutation of mutationsList) {
//       if (mutation.type === 'attributes' && mutation.attributeName === 'data-test-4') {
//         const dataTest4 = document.body.getAttribute('data-test-4');
//         if (dataTest4 === 'true') {
//           const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
//           if (reviewWidgets.length > 0) {
//             executeLogic();
//             observer.disconnect();
//             break;
//           }
//         }
//       }
//       if (mutation.type === 'childList') {
//         const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
//         const dataTest4 = document.body.getAttribute('data-test-4');
//         if (reviewWidgets.length > 0) {
//           executeLogic();
//           // observer.disconnect();
//           // break;
//         }
//       }
//     }
//   });
//   observer.observe(document.body, {
//     childList: true,
//     attributes: true,
//     subtree: true
//   });

if(window.location.pathname == '/'){
  function executeOnceOnScroll() {
    const scrollThreshold = 1700;
    function onScroll() {
      if (window.scrollY >= scrollThreshold) {
        if(document.getElementsByClassName("klaviyo-featured-review-block")[0]){
          document.getElementsByClassName("klaviyo-featured-review-block")[0].setAttribute("id","klaviyo-featured-reviews-carousel")
        }
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll);
  }
  executeOnceOnScroll();
}

window.update_review = function(){
  const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
  reviewWidgets.forEach(widget => {
    const ariaLabel = widget.getAttribute('aria-label');
    const starRatingMatch = ariaLabel.match(/(\d+(\.\d+)?) stars/);
    const reviewCountMatch = ariaLabel.match(/(\d+) ratings/);
    let starRating = starRatingMatch ? parseFloat(starRatingMatch[1]).toFixed(1) : null;
    const reviewCount = reviewCountMatch ? reviewCountMatch[1] : null;
    if (starRating && (parseFloat(starRating) % 1 === 0)) {
      starRating = parseInt(starRating);
    }
    if (starRating && reviewCount > 0) {
      if (widget.parentNode.querySelectorAll('.reviews__details').length == 0) {
        const reviewContainer = document.createElement('div');
        reviewContainer.classList.add('reviews__details');
        reviewContainer.innerHTML = `<div class="reviews__averange">${starRating}</div><div class="reviews__reviews">(${reviewCount})</div>`;
        widget.parentNode.insertBefore(reviewContainer, widget.nextSibling);
      }
    } else if (reviewCount <= 0 || reviewCount === null){
    }
  });
}

window.update_widget = function(){
  var counter = 0;
  const maxCount = 5;
  const intervalId = setInterval(() => {
    window.update_review();
    counter++;
    if (counter >= maxCount) {
      clearInterval(intervalId);
    }
  }, 1000);
}
window.update_widget();

// $(".search-modal__form .search__input").keyup()
// if ($('.box').is(':hover')) {
// $('.box').on('mouseenter', function() { 
//     console.log('Hovered!');
// });

// $('.box').on('mouseleave', function() {
//     console.log('Not hovered!');
// });

$(".search-modal__form .search__input").on('keypress keyup', function(){
  if($(this).val().length == 0){
    $('.search-recommend-wrapper').show();
    $('body').addClass('autosuggest_box_open');
  }else{
    setTimeout(function(){
      $('.search-recommend-wrapper').hide();
      $('body').removeClass('autosuggest_box_open');
    }, 100);
  }
});

$(".search-modal__form .search__input").focusin(function() {
  $('.search-recommend-wrapper').show();
  $('body').addClass('autosuggest_box_open');
});

$(document).click(function(event) {
  if (!$(event.target).closest('.search-recommend-wrapper, .header__search').length) {
    $('.search-recommend-wrapper').hide();
    $('body').removeClass('autosuggest_box_open');
  }
});


// Commented out search focus out handler
// $(".search-modal__form .search__input").focusout(function() {
//   setTimeout(function(){
//     $('.search-recommend-wrapper').hide();
//   }, 100);
// });

// setInterval(function(){
//   $('.animate__animated').addClass("animate__bounce");
//   setTimeout(function(){
//     $('.animate__animated').removeClass("animate__bounce");
//   },2500);
// },4000);

$(document).on('change', '#nosto-new-bundle .nosto-variant', function() {
  var $image = $(this).find("option:selected").data('img');
  if($image){
    $(this).parents(".nosto-item").find("a img").attr("src",$image+"&width=400").attr("srcset",$image+"&width=400");
  }
});

$('.globo-product-recommendations .spf-product-card').each(function(){
  var $this = $(this),
      $pid = $this.find('[bss-b2b-product-id]').attr('bss-b2b-product-id'),
      $title = $(this).find('.spf-product-card__title a').text(),
      $url = $(this).find('.spf-product-card__title a').attr('href'),
      $klaviyo_widget = `<div class="klaviyo-star-rating-widget" data-id="${$pid}" data-product-title="${$title}"></div>`,
      $quick_buy = `<modal-opener data-modal="#QuickAdd-${$pid}"> <button id="${$pid}-submit" type="submit" name="add" class="quick-add__submit-- button button--full-width--" aria-haspopup="dialog" aria-labelledby="${$pid}-submit" data-product-url="${$url}" > Quick Buy <div class="loading__spinner hidden"> <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" > <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> </svg> </div> </button> </modal-opener>`,
      $quick_buy_model = `<quick-add-modal id="QuickAdd-${$pid}" class="quick-add-modal"> <div role="dialog" aria-label="${$title}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1" > <button id="ModalClose-${$pid}" type="button" class="quick-add-modal__toggle" aria-label="Close" > <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17" > <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"> </svg> </button> <div id="QuickAddInfo-${$pid}" class="quick-add-modal__content-info"></div> </div> </quick-add-modal>`;
      if($this.find('.spf-product-card__title .klaviyo-star-rating-widget').length == 0) $this.find('.spf-product-card__title').after($klaviyo_widget);
      if($this.find('.spf-product-card__title .quick-add__submit-- button').length == 0) $this.find('.spf-product-card__price-wrapper').after($quick_buy+$quick_buy_model);
      // if($url == ""){
      //   if($(this).find('.spf-product-card__inner .block_custom-awards-badge-home').length == 0) $this.find('.spf-product-card__inner').prepend();
      // }
});


const equalizeFeatureBoxHeight = () => {
  const boxes = [...document.querySelectorAll('.ep-feature-box')];
  if (!boxes.length) return;

  boxes.forEach(b => b.style.height = 'auto');

  const maxHeight = Math.max(...boxes.map(b => b.offsetHeight));
  boxes.forEach(b => (b.style.height = `${maxHeight}px`));
};

window.addEventListener('load', equalizeFeatureBoxHeight);
window.addEventListener('resize', equalizeFeatureBoxHeight);

document.addEventListener('click', (e) => {
  // OPEN popup
  if (e.target.closest('.ins-more-info')) {
    const popup = document.querySelector('.ep-info-popup');
    if (!popup) return;

    popup.style.display = 'block';
    equalizeFeatureBoxHeight();
    document.body.classList.add('overflow-hidden');
  }

  // CLOSE popup
  if (e.target.closest('.ep-model-close')) {
    const popup = document.querySelector('.ep-info-popup');
    if (!popup) return;

    popup.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }
});

// frequently-bought div move js start
function moveFormOutsideContainer() {

  if (!window.matchMedia("(max-width: 989px)").matches) return;

  var container = document.querySelector('.cbb-frequently-bought-recommendations-container');
  var form = document.querySelector('.cbb-frequently-bought-form');

  if (!container || !form) return;

  // Prevent duplicate move
  if (form.classList.contains('moved-outside')) return;

  container.insertAdjacentElement('afterend', form);
  form.classList.add('moved-outside');
}

// Observe DOM changes (CBB loads via AJAX)
var observer = new MutationObserver(function () {
  moveFormOutsideContainer();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Initial run
document.addEventListener('DOMContentLoaded', moveFormOutsideContainer);
// frequently-bought div move js  end

$(document).on("click",".whey-freebie-overlay, .whey-freebie-header .icon-close",function() {
  $('.whey-freebie-wrapper').removeClass('open-whey-offer')
  $('.whey-freebie-drawer').removeClass('open-drawer')
  document.body.classList.remove('overflow-hidden');
});

function closeUnbxdMobileFacetDrawer() {
  document.querySelectorAll(".UNX-facet-wrapper").forEach(function (el) {
    el.classList.remove("open-drawer");
  });
}

$(document).on("click", ".UNX-mobile-filter", function () {
  $(".UNX-facet-wrapper").addClass("open-drawer");
});

$(document).on("click", ".block__facet-close--button", function () {
  closeUnbxdMobileFacetDrawer();
});

$(document).on(
  "click",
  '.UNX-m-facet-actions [data-facet-action="applyFacets"], .UNX-m-facet-actions [data-action="applyFacets"]',
  function (e) {
    var search = window.unbxdSearch;
    if (!search) return;

    e.preventDefault();
    e.stopPropagation();

    search.viewState.lastAction = "applyFacets";
    search.setPageStart(0);
    search.getResults();
    closeUnbxdMobileFacetDrawer();
  }
);

$(document).on(
  "click",
  '.UNX-m-facet-actions [data-facet-action="clearAllFacets"], .UNX-m-facet-actions [data-action="clearFacets"]',
  function (e) {
    var search = window.unbxdSearch;
    if (!search) return;

    e.preventDefault();
    e.stopPropagation();

    search.viewState.lastAction = "clearAllFacets";

    // clearFacets() only removes text facets; price uses state.rangeFacet
    if (typeof search.clearAllFacets === "function") {
      search.clearAllFacets();
    } else {
      search.state.selectedFacets = {};
      search.state.rangeFacet = {};
      search.state.categoryFilter = {};
    }

    search.setPageStart(0);
    if (typeof search.renderFacets === "function") {
      search.renderFacets();
    }
    if (typeof search.renderSelectedFacets === "function") {
      search.renderSelectedFacets();
    }
    search.getResults();
    if (window.scheduleUnbxdFacetsTrack) {
      window.scheduleUnbxdFacetsTrack(search, { delay: 350, cleared: true });
    }
    closeUnbxdMobileFacetDrawer();
  }
);

// $unbxd_url = "https://search.unbxd.io/a96ed837cb0a5005a2e2fef6ae6439fb/ss-unbxd-aapac-prod-elitesupp-sg14461770952608/autosuggest?q=*&topQueries.count=10&popularProducts.count=0&inFields.count=0";
// fetch($unbxd_url).then(res => res.json()).then(response => {
//     response = response.response;
//     for(i=0; i < response.products.length; i++){
//         var $result = response.products[i];
//         if($result.doctype == "TOP_SEARCH_QUERIES"){
//           $('.elite-popular-collections-link.unbxd-links').append(`<a href="/search?q=${$result.autosuggest}">${$result.autosuggest}</a>`);
//           $('.elite-popular-search-links.source-unbxd').append(`<a href="/search?q=${$result.autosuggest}">${$result.autosuggest}</a>`);
//         }
//     }
// });